export default "__VITE_ASSET__Dm4A$GfQ__"